import * as React from 'react';
import * as styles from './ProjectCard.css';
import { IBuilderInfo } from '../../types/buildersProjects';
import { LinkArea } from '../LinkArea';
import { BuilderInfo, IGalleryProps, Gallery, IProjectInfoProps, ProjectInfo } from './components';
import { Responsive } from '@cian/ui-kit';
import { TourLabel } from './components/TourLabel';

interface IProjectCardProps extends IGalleryProps, IProjectInfoProps {
  builder: IBuilderInfo;
  phoneButton: React.ReactNode;
  onCardClick(): void;
  onGalleryClick(): void;
  url: string;
  hasTour: boolean;
  labels: React.ReactNode;
}

export const ProjectCard: React.FC<IProjectCardProps> = ({
  images,
  name,
  parameters,
  constructionTime,
  description,
  price,
  url,
  builder,
  phoneButton,
  hasTour,
  onCardClick,
  onGalleryClick,
  labels,
}) => {
  return (
    <LinkArea href={url} onClick={onCardClick} className={styles['container']} dataName="ProjectCard">
      <div className={styles['gallery']} onClick={onGalleryClick}>
        <Gallery images={images} />
        {hasTour && <TourLabel />}
      </div>
      <div className={styles['project-info']}>
        <Responsive tablet phone>
          <div className={styles['labels']}>{labels}</div>
        </Responsive>
        <ProjectInfo
          name={name}
          parameters={parameters}
          constructionTime={constructionTime}
          description={description}
          price={price}
          labels={labels}
        />
      </div>
      <div className={styles['builder-info']}>
        <BuilderInfo {...builder} phoneButton={phoneButton} />
      </div>
      <Responsive tablet phone>
        <div className={styles['phone-button']}>{phoneButton}</div>
      </Responsive>
    </LinkArea>
  );
};
